import React, { useState } from 'react';
import { Text, Button, DatePicker } from '../../Atoms';
import { COLOR_BUTTON } from '../../Config/Config';
import { Input } from '../../Molecules';
import propTypes from 'prop-types';

const ConfirmationForm = ({ onClose, validationCodeSuccess, beneficiaryName, onConfirmDeletion, navigationSteps }) => {

  const [dateEffet, setDateEffet] = useState(null);
  const [commentaire, setCommentaire] = useState('');
  const [dateError, setDateError] = useState(false);

  const onChangeDateEffet = (e) => {
    setDateEffet(e);
    setDateError(false);
  };

  const onChangeCommentaire = (e) => setCommentaire(e.target.value);

  const handleValidation = () => {
    if (!dateEffet) {
      setDateError(true);
      return;
    }
    onConfirmDeletion(commentaire, dateEffet);
  };

  const handleContinueClick = () => {
    navigationSteps('PICK_BENEFICIAIRE');
  };

  return (
    <div className="confirmation-modal">
      {!validationCodeSuccess ? (
        <div>
          <div
            className="col-8"
          >
            <Button
              type="primary"
              text={beneficiaryName}
              color={COLOR_BUTTON.GREEN}
            />
          </div>
          <div className="col-8">
            <div className="text-description-confirm-password pt-20">
              Votre demande de suppression de bénéficiaire sera envoyée et traitée par notre service adhésion.
            </div>
            <div className="text-description-confirm-password">
              Souhaitez-vous valider la suppression de <span className="text-bold">{beneficiaryName}</span> ?
            </div>
          </div>

          <div className="col-4 mb-30">
            <Text text="Ajouter un commentaire à ma demande :" className="text-description-confirm-password pt-10" />
            <Input
              placeholder="Laissez un commentaire"
              className="input-decription-document input-description-medicine"
              onChange={onChangeCommentaire}
              value={commentaire}
              as="textarea"
            />
          </div>

          <div className="col-2">
            <DatePicker
              inputLabel="Choisir la date d'effet *"
              placeholder="JJ/MM/AAAA"
              renderIcon={false}
              containerClassName="full-container"
              className={`full-container ${dateError ? 'error-border' : ''}`}
              onChange={onChangeDateEffet}
              selected={dateEffet}
            />
            {dateError && (
              <Text text="La date d'effet est obligatoire" className="text-error"
                    style={{ color: 'red', fontSize: '12px' }} />
            )}
          </div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button type="primary" text="Annuler" className="btn-cancel-modal-delete-profile" onClick={onClose}
                    color={COLOR_BUTTON.BLACK} isAlreadyOutline />
            <Button type="primary" text="Valider" className="btn-submit-modal-edit-profile" onClick={handleValidation}
                    color={COLOR_BUTTON.GREEN} />
          </div>
        </div>
      ) : (
        <div className="col-8 mt-20">
          <Text text={`Votre demande de suppression de ${beneficiaryName} a bien été envoyée à notre service adhésion.`}
                className="text-description-confirm-password" />
          <Text text="Nous vous recontacterons dans les plus brefs délais." className="text-description-confirm-password" />

          <div style={{ display: 'flex', justifyContent: 'left' }}>
            <Button type="primary" text="Continuer" className="btn-cancel-modal-delete-profile" onClick={handleContinueClick} color={COLOR_BUTTON.BLACK} isAlreadyOutline />
          </div>
        </div>
      )}
    </div>
  );
};

const handleContinueClick = () => {
  navigationSteps('PICK_BENEFICIAIRE');
};

ConfirmationForm.propTypes = {
  onClose: propTypes.func,
  validationCodeSuccess: propTypes.bool,
  beneficiaryName: propTypes.string,
  onConfirmDeletion: propTypes.func,
  navigationSteps: propTypes.func
};

export default ConfirmationForm;
